import React from "react";
import styled from "styled-components";
import Header from "./Header"
import Body from "./Body";
import Footer from "./Footer";

export const CardContainer = styled.div`
    background-color: white;
    border-radius: 15px;
    padding-top: 1px;
    margin-bottom: 10px;
    -webkit-box-shadow: 1px 30px 40px -1px rgba(5, 107, 170, 0.39);
    -moz-box-shadow: 1px 30px 40px -1px rgba(5, 107, 170, 0.39);
    box-shadow: 1px 30px 40px -1px rgba(5, 107, 170, 0.39);
`;

export {
    Header,
    Body,
    Footer
}


// WEBPACK FOOTER //
// ./src/_components/Card/components/index.jsx